/**
 * Keyclic API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.24.5
 * Contact: techies@keyclic.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface FeedbackStatePatch { 
    transition: FeedbackStatePatch.TransitionEnum;
}
export namespace FeedbackStatePatch {
    export type TransitionEnum = 'accept' | 'reaccept' | 'refuse';
    export const TransitionEnum = {
        Accept: 'accept' as TransitionEnum,
        Reaccept: 'reaccept' as TransitionEnum,
        Refuse: 'refuse' as TransitionEnum
    };
}
